import operatorApiFetch from './apiService';

const purchaseOrderService = {
  getRecords: async (params = {}) => {
    const res = await operatorApiFetch('purchase_orders/get_records', { method: 'POST', body: params });
    return res.json();
  },

  getIds: async (params = {}) => {
    const res = await operatorApiFetch('purchase_orders/get_ids', { method: 'POST', body: params });
    return res.json();
  },

  export: async (ids) => {
    const res = await operatorApiFetch('purchase_orders/export', { method: 'POST', body: { ids } });
    return res.json();
  },

  get: async (id) => {
    const res = await operatorApiFetch(`purchase_orders/${id}`, { method: 'GET' });
    return res.json();
  },

  suggestName: async () => {
    const res = await operatorApiFetch('purchase_orders/suggest_name', { method: 'GET' });
    return res.json();
  },

  create: async (data) => {
    const res = await operatorApiFetch('purchase_orders', { method: 'POST', body: { purchase_order: data } });
    return res.json();
  },

  update: async (id, data) => {
    const res = await operatorApiFetch(`purchase_orders/${id}`, { method: 'PUT', body: { purchase_order: data } });
    return res.json();
  },

  submit: async (id) => {
    const res = await operatorApiFetch(`purchase_orders/${id}/submit`, { method: 'POST' });
    return res.json();
  },

  approve: async (id) => {
    const res = await operatorApiFetch(`purchase_orders/${id}/approve`, { method: 'POST' });
    return res.json();
  },

  reject: async (id) => {
    const res = await operatorApiFetch(`purchase_orders/${id}/reject`, { method: 'POST' });
    return res.json();
  },

  cancel: async (id) => {
    const res = await operatorApiFetch(`purchase_orders/${id}/cancel`, { method: 'POST' });
    return res.json();
  },

  shortClose: async (id, closeReason) => {
    const res = await operatorApiFetch(`purchase_orders/${id}/short_close`, { method: 'POST', body: { close_reason: closeReason } });
    return res.json();
  },

  close: async (id) => {
    const res = await operatorApiFetch(`purchase_orders/${id}/close`, { method: 'POST' });
    return res.json();
  },

  createInbound: async (id, data) => {
    const res = await operatorApiFetch(`purchase_orders/${id}/create_inbound`, { method: 'POST', body: data });
    return res.json();
  },

  getHistories: async (id) => {
    const res = await operatorApiFetch(`purchase_orders/${id}/purchase_order_histories`, { method: 'GET' });
    return res.json();
  },
};

export { purchaseOrderService };
export default purchaseOrderService;
